<template>
  <div v-if="modelValue" :type="type" :class="['loading-wrap', {'loading-layer': type === 'layer'}]">
    <div class="loading-inner">
      <span class="loading-dot"></span>
      <span class="loading-dot"></span>
      <span class="loading-dot"></span>
    </div>
  </div>
</template>
<script setup lang="ts">
import { watch, onUnmounted } from 'vue';

interface Props {
  modelValue: boolean;
  type?: '' | 'layer';
}
const props = withDefaults(defineProps<Props>(), {
	modelValue: false,
  type: ''
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
}>();

const closeLoading = (): void => {
  emit('update:modelValue', false);
}

watch(() => props.modelValue, (newValue: boolean) => {
  if(props.type === 'layer' && newValue) {
    document.body.style.overflow = 'hidden';
  }
});

const handleAfterLeave = (): void => {
  if(props.type === 'layer'){
    document.body.style.overflow = '';
  }
}

onUnmounted(() => {
  handleAfterLeave();
});

</script>
<style lang="scss" scoped>
.loading-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;

  &.loading-layer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  }

  .loading-inner {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    .loading-dot {
      display: block;
      width: 8px;
      height: 8px;
      background-color: #0a583f;
      border-radius: 100%;
      animation: loading 1s linear infinite;

      &:nth-child(2) {
        animation-delay: 0.2s;
      }
      &:nth-child(3) {
        animation-delay: 0.4s;
      }
    }
  }

  @keyframes loading {
    0%, 100% {
      opacity: 0;
      transform: scale(0.5);
    }
    50% {
      opacity: 1;
      transform: scale(1.2);
    }
  }
}
</style>